module.exports = __webpack_public_path__ + "assets/img/progress-circle.svg";